// extracted by mini-css-extract-plugin
export default {"container":"Widget_container__Xu1Bt","title":"Widget_title__0tmm+"};